import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafeModule, TabNavigationModule } from '@com-delta-idp/mnx-ui-kit';
import { OfferDetailsBannerComponent } from './offer-details-banner.component';

@NgModule({
  declarations: [OfferDetailsBannerComponent],
  imports: [CommonModule, SafeModule, TabNavigationModule],
  exports: [OfferDetailsBannerComponent]
})
export class OfferDetailsBannerModule {}
